// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "monthsList-1UVdP";
var _4 = "monthsList_withPrice-3OlLc";
var _5 = "month-TH2IG";
export { _1 as "__esModule", _2 as "tablet", _3 as "monthsList", _4 as "monthsList_withPrice", _5 as "month" }
export default { "__esModule": _1, "tablet": _2, "monthsList": _3, "monthsList_withPrice": _4, "month": _5 }
